import { render } from "./AvatarUploadDialog.vue?vue&type=template&id=3e307f88&scoped=true"
import script from "./AvatarUploadDialog.vue?vue&type=script&lang=js"
export * from "./AvatarUploadDialog.vue?vue&type=script&lang=js"

import "./AvatarUploadDialog.vue?vue&type=style&index=0&id=3e307f88&lang=less&scoped=true"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e307f88"]])

export default __exports__